import { Container } from '@mui/material'
import CheckNow from '../../../Components/Public/CheckNow/CheckNow';
import BlogLayout from '../../../Components/Public/Blog/BlogLayout';
import ErrorContainer from './ErrorContainer';

export default function ErrorPage() {


    return (
        <Container maxWidth='xl' sx={{}}>
            <ErrorContainer />
            <CheckNow sx={{ mb: '40px' }} />
            <BlogLayout />
        </Container>
    )
}
